import { Project } from "../pages/candidate/CandidateProfileEditNew";

export const validateSingleProject = (project: Project) => {
  const errors: any = {};

  if (!project.name.trim()) {
    errors.project_name = "Project name is required";
  }

  if (!project.description?.trim()) {
    errors.description = "Project description is required";
  }

  if (!project.start_date) {
    errors.start_date = "Start date is required";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (project.start_date) {
    const start = new Date(project.start_date);

    if (start > today) {
      errors.start_date = "Start date cannot be in the future";
    }
  }

  if (!project.is_ongoing) {
    if (!project.end_date) {
      errors.end_date = "End date is required";
    }

    if (project.start_date && project.end_date) {
      const start = new Date(project.start_date);
      const end = new Date(project.end_date);

      if (end < start) {
        errors.end_date = "End date cannot be before start date";
      }
    }
  }

  if (project.url) {
    try {
      new URL(project.url);
    } catch {
      errors.project_url = "Invalid project URL";
    }
  }

  return errors;
};